videojs.addLanguage('ar', {
  "Play": "تشغيل",
  "Pause": "إيقاف",
  "Current Time": "الوقت الحالي",
  "Duration": "المدة",
  "Remaining Time": "الوقت المتبقي",
  "Stream Type": "نوع التيار",
  "LIVE": "مباشر",
  "Loaded": "تم التحميل",
  "Progress": "التقدم",
  "Fullscreen": "ملء الشاشة",
  "Exit Fullscreen": "تعطيل ملء الشاشة",
  "Mute": "كتم",
  "Unmute": "إلغاء الكتم",
  "Playback Rate": "سرعة التشغيل",
  "Subtitles": "الترجمة",
  "subtitles off": "إيقاف الترجمة",
  "Captions": "التسمية التوضيحية",
  "captions off": "إيقاف التسمية التوضيحية",
  "Chapters": "الفصول",
  "You aborted the media playback": "لقد ألغيت تشغيل الفيديو",
  "A network error caused the media download to fail part-way.": "تسبب خطأ في الشبكة بفشل تحميل الفيديو بالكامل.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "لا يمكن تحميل الفيديو بسبب فشل في الخادم أو الشبكة ، أو بسبب عدم إمكانية قراءة تنسيق الفيديو.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "تم إيقاف تشغيل الفيديو بسبب عدم صلاحية الفيديو أو لأن الفيديو المستخدم يستخدم ميزات غير مدعومة من متصفحك.",
  "No compatible source was found for this media.": "فشل العثور على أي مصدر متوافق مع هذا الفيديو.",
  "Play Video": "تشغيل الفيديو",
  "Close": "أغلق",
  "Modal Window": "النافذة",
  "This is a modal window": "هذه نافذة",
  "This modal can be closed by pressing the Escape key or activating the close button.": "يمكن غلق هذه النافذة عن طريق الضغط على زر الخروج أو تفعيل زر الإغلاق",
  ", opens captions settings dialog": ", تفتح نافذة خيارات التسمية التوضيحية",
  ", opens subtitles settings dialog": ", تفتح نافذة خيارات الترجمة",
  ", selected": ", مختار",
  "Audio Player": "مشغل الصوت",
  "Video Player": "مشغل الفيديو",
  "Replay": "إعادة التشغيل",
  "Seek to live, currently behind live": "الذهاب إلى نقطة البث المباشر، متأخر عن البث المباشر حاليًا",
  "Seek to live, currently playing live": "الذهاب إلى نقطة البث المباشر، البث المباشر قيد التشغيل حاليًا",
  "Progress Bar": "شريط التقدم",
  "progress bar timing: currentTime={1} duration={2}": "{1} من {2}",
  "Descriptions": "الوصف",
  "descriptions off": "إخفاء الوصف",
  "Audio Track": "المسار الصوتي",
  "Volume Level": "مستوى الصوت",
  "The media is encrypted and we do not have the keys to decrypt it.": "الوسائط مشفرة وليس لدينا الرموز اللازمة لفك شفرتها.",
  "Close Modal Dialog": "إغلاق مربع الحوار المشروط",
  ", opens descriptions settings dialog": "، يفتح نافذة إعدادات الوصف",
  "captions settings": "إعدادات التعليقات التوضيحية",
  "subtitles settings": "إعدادات الترجمات",
  "descriptions settings": "إعدادات الوصف",
  "Text": "النص",
  "White": "أبيض",
  "Black": "أسود",
  "Red": "أحمر",
  "Green": "أخضر",
  "Blue": "أزرق",
  "Yellow": "أصفر",
  "Magenta": "أرجواني",
  "Cyan": "أزرق سماوي",
  "Background": "الخلفية",
  "Window": "نافذة",
  "Transparent": "شفاف",
  "Semi-Transparent": "نصف شفاف",
  "Opaque": "معتم",
  "Font Size": "حجم الخط",
  "Text Edge Style": "نمط حواف النص",
  "None": "لا شيء",
  "Raised": "بارز",
  "Depressed": "منخفض",
  "Uniform": "منتظم",
  "Drop shadow": "الظل",
  "Font Family": "عائلة الخطوط",
  "Proportional Sans-Serif": "Proportional Sans-Serif",
  "Monospace Sans-Serif": "Monospace Sans-Serif",
  "Proportional Serif": "Proportional Serif",
  "Monospace Serif": "Monospace Serif",
  "Casual": "Casual",
  "Script": "Script",
  "Small Caps": "Small Caps",
  "Reset": "إعادة الضبط",
  "restore all settings to the default values": "استعادة كل الإعدادات إلى القيم الافتراضية",
  "Done": "تم",
  "Caption Settings Dialog": "نافذة إعدادات التعليقات التوضيحية",
  "Beginning of dialog window. Escape will cancel and close the window.": "بداية النافذة. الضغط على زر \"Escape\" سيؤدي إلى الإلغاء وإغلاق النافذة.",
  "End of dialog window.": ".نهاية النافذة",
  "{1} is loading.": "{1} قيد التحميل.",
  "Exit Picture-in-Picture": "الخروج من وضع صورة داخل صورة",
  "Picture-in-Picture": "صورة داخل صورة",
  "No content": "لا يوجد محتوى",
  "Color": "اللون",
  "Opacity": "معدل الشفافية",
  "Text Background": "خلفية النص",
  "Caption Area Background": "خلفية منطقة التسمية التوضيحية",
  "Playing in Picture-in-Picture": "صورة داخل صورة قيد التشغيل",
  "Skip forward {1} seconds": "التخطي للأمام {1}",
  "Skip backward {1} seconds": "الرجوع للخلف {1}"
});